/* Original banner layout; current cart is the source of shipping progress. */
(() => {
  if (customElements.get('shipping-progress-banner')) return;
  class ShippingProgressBanner extends HTMLElement {
    connectedCallback() {
      this.refresh = () => this.refreshFromCart();
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, this.refresh);
      }
      document.addEventListener('cart:updated', this.refresh);
    }
    disconnectedCallback() {
      this.unsubscribe?.();
      document.removeEventListener('cart:updated', this.refresh);
      this.controller?.abort();
    }
    async refreshFromCart() {
      this.controller?.abort();
      const controller = new AbortController();
      this.controller = controller;
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart.js`, {cache:'no-store', signal:controller.signal});
        if (!response.ok) return;
        const cart = await response.json();
        if (this.isConnected && !controller.signal.aborted) this.render(cart);
      } catch (error) { /* Retain the current server-rendered message on failure. */ }
    }
    render(cart) {
      const threshold = Number(this.dataset.threshold);
      const maximum = Number(this.dataset.maximum);
      const valid = threshold > 0 && cart.currency === this.dataset.currency && cart.item_count > 0 && cart.total_price <= maximum;
      const remaining = Math.max(0, threshold - cart.total_price);
      const message = this.querySelector('[data-ship-message]');
      const track = this.querySelector('[data-ship-track]');
      const fill = this.querySelector('[data-ship-fill]');
      if (!message || !track || !fill) return;
      let text = cart.item_count === 0 ? (this.dataset.emptySummary || this.dataset.summary) : this.dataset.summary;
      if (valid) {
        const money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:cart.currency, currencyDisplay:'code'}).format(remaining / 100);
        text = remaining > 0 ? this.dataset.remaining.replace('__AMOUNT__',money) : this.dataset.reached;
      }
      message.textContent = text;
      track.hidden = !valid;
      const percent = valid ? Math.min(100, Math.floor(cart.total_price * 100 / threshold)) : 0;
      track.setAttribute('aria-valuenow', String(percent));
      fill.style.width = `${percent}%`;
    }
  }
  customElements.define('shipping-progress-banner',ShippingProgressBanner);
})();
